import React, { useMemo } from "react";
import { Table } from "antd";

const getDelayRateBadge = (rate) => {
  let badgeStyle = {
    padding: "4px 10px",
    borderRadius: "9999px",
    fontSize: "12px",
    fontWeight: "500",
    backgroundColor: "rgba(34, 197, 94, 0.1)",
    color: "#22c55e",
  };
  if (rate > 12) {
    badgeStyle.backgroundColor = "rgba(239, 68, 68, 0.1)";
    badgeStyle.color = "#ef4444";
  } else if (rate > 8) {
    badgeStyle.backgroundColor = "rgba(245, 158, 11, 0.1)";
    badgeStyle.color = "#f59e0b";
  }

  return <span style={badgeStyle}>{rate.toFixed(1)}%</span>;
};

const columns = [
  {
    title: "Team Member",
    dataIndex: "member",
    key: "member",
    render: (text) => <span style={{ fontWeight: "500" }}>{text}</span>,
  },
  {
    title: "Delayed Tasks",
    dataIndex: "delayedTasks",
    key: "delayedTasks",
    align: "center",
    render: (val) => (
      <span style={{ color: "#ef4444", fontWeight: "600" }}>{val}</span>
    ),
  },
  {
    title: "Total Tasks",
    dataIndex: "totalTasks",
    key: "totalTasks",
    align: "center",
    render: (val) => <span style={{ fontWeight: "500" }}>{val}</span>,
  },
  {
    title: "Delay Rate",
    dataIndex: "delayRate",
    key: "delayRate",
    align: "center",
    render: (rate) => getDelayRateBadge(rate),
  },
];

const DelayBreakdownTable = ({ data = [] }) => {
  const tableData = useMemo(() => {
    return data.map((item, index) => ({
      key: item.subscriber__id || index,
      member:
        `${item.subscriber__first_name || ""} ${
          item.subscriber__last_name || ""
        }`.trim() || "Unknown",
      delayedTasks: item.delayed_tasks || 0,
      totalTasks: item.total_tasks || 0,
      delayRate:
        item.total_tasks > 0
          ? (item.delayed_tasks / item.total_tasks) * 100
          : 0,
    }));
  }, [data]);

  const totalDelayed = tableData.reduce(
    (sum, row) => sum + row.delayedTasks,
    0
  );

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "16px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}
      >
        <h3 style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>
          Delay Breakdown by Member
        </h3>
        <span style={{ fontSize: "14px", color: "#6b7280" }}>
          Total Delayed:{" "}
          <span style={{ fontWeight: "600", color: "#ef4444" }}>
            {totalDelayed}
          </span>
        </span>
      </div>
      <Table
        columns={columns}
        dataSource={tableData}
        pagination={false}
        size="small"
        scroll={{ y: 300 }}
      />
    </div>
  );
};

export default DelayBreakdownTable;
